import React from 'react';

const ContactUsModal = () => {
    return (
        <div className="modal fade" id="contact_us_modal" tabIndex={-1} role="dialog" aria-labelledby="contact_us_modal" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-12">
                                <div className="card mb-4">
                                    <div style={{ height: "50px" }} className="card-header">Contact</div>
                                    <div className="card-body">
                                        <p>Contact us today and one of our friendly representatives will get back to you as soon as possible.</p>
                                        <ul className="list-unstyled">
                                            <li><strong>Office:</strong> (469) 637-0100</li>
                                            <li><strong>Toll Free:</strong> (855) 389-2886</li>
                                            <li><strong>Fax:</strong> (469) 637-0110</li>
                                            <br />
                                            <li><strong>Business Hours:</strong></li>
                                            <li>Monday - Thursday: 8:30 AM - 7:00 PM CST</li>
                                            <li>Friday: 8:30 am - 5:30 pm CST</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(ContactUsModal);
